// src/BankSearchBar.js
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

/**
 * BankSearchBar:
 * - /api/bank-names endpoint'inden unique banka isimlerini çeker
 * - react-select ile autocomplete / dropdown list sağlar
 * - onSelect callback'iyle seçimi parent bileşene iletir
 */
const BankSearchBar = ({ onSelect, placeholder = "Search for a bank..." }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetch('/api/bank-names')
      .then(res => res.json())
      .then(names => {
        const opts = names.map(name => ({ value: name, label: name }));
        setOptions(opts);
      })
      .catch(err => console.error("Error fetching bank names:", err));
  }, []);

  return (
    <Select
      options={options}
      placeholder={placeholder}
      isClearable
      onChange={onSelect}
      classNamePrefix="bank-search"
    />
  );
};

export default BankSearchBar;
